import React, {
  type RefObject,
  type CSSProperties,
  type ReactNode,
  type ReactElement,
} from "react";

/**
 * Pass a loading state down a component tree, recursing over any fragments
 * */
export const renderChildrenWithLoading = (
  children: React.ReactNode,
  loading: boolean,
) => {
  return React.Children.map(
    children,
    (child: React.ReactElement<Record<string, unknown>>) => {
      if (React.isValidElement(child)) {
        if (React.Fragment === child.type) {
          // If child is a fragment, render its children recursively
          return renderChildrenWithLoading(child.props.children, loading);
        }
        // Clone the child with the loading prop
        return React.cloneElement(child, { loading, ...(child.props as any) });
      }
      return child;
    },
  );
};

// call before collapsing something - if its top is scrolled above `offset`
// (e.g. behind a fixed nav), brings it into view first so the page doesn't
// end up scrolled into whatever used to be further down
export const scrollIntoViewIfOffscreen = (
  element: HTMLElement | null,
  offset = 0,
) => {
  if (!element) return;

  const { top } = element.getBoundingClientRect();
  if (top < offset) {
    window.scrollBy({ top: top - offset });
  }
};
